import React from 'react';
import Chip from '~components/atoms/Chip';
import Table from '~components/molecules/Table';
import { useAppSelector } from '~redux/hooks';
import { SerialNumberStatusEnum } from '~utils/enums';

const StockOutTable = () => {
    const serialNumberListing = useAppSelector(state => state.gold.serialNumber.serialNumberListing.data);
    const isLoading = useAppSelector(state => state.gold.loadings.getSerialNumberListing);

    const tableHeader = [
        'PRODUCT NAME',
        'AMOUNT',
        'SERIAL NUMBER',
        'STATUS',
        'DATE',
    ];

    const tableData = serialNumberListing.map(item => {
        const {
            productName,
            status,
            physicalGoldWeight,
            serialNo,
            branchCode,
            branchName,
            customerName,
            CIFNo,
        } = item;

        const renderSerialNumberStatusChip = () => {
            switch (status) {
                case SerialNumberStatusEnum.Unsold: {

                    return <Chip
                        type='success'
                        label='Unsold'
                    />;
                }

                case SerialNumberStatusEnum.Sold: {
                    return <Chip
                        type='inactive'
                        label='Sold'
                    />;

                }
            }
        };

        return [
            productName,
            renderSerialNumberStatusChip(),
            physicalGoldWeight || 'N/A',
            serialNo,
            branchCode,
            branchName,
            customerName || '-',
            CIFNo || '-',
        ];
    });

    return (
        <Table
            header={tableHeader}
            body={tableData}
            isLoading={isLoading}
        />
    );
};

export default StockOutTable;
